export const config = {
  videoTypes: [
    {
      label: "File",
      value: "file",
      setup: (src) => {
        return { sources: [{ type: "video/mp4", src: src + "#t=0.001" }] };
      },
    },
    {
      label: "Youtube",
      value: "youtube",
      setup: (src) => {
        return {
          controls: true,
          controlBar: false,
          techOrder: ["youtube"],
          sources: [{ type: "video/youtube", src: src }],
          youtube: { ytControls: 2 },
        };
      },
    },
    // {
    //   label: "Vimeo",
    //   value: "vimeo",
    //   setup: (src) => {
    //     return {
    //       techOrder: ["vimeo"],
    //       sources: [{ type: "video/vimeo", src: src }],
    //     };
    //   },
    // },
  ],
};
